import { Button, ButtonGroup, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

interface SegmentedControlProps {
    options: { id: string; label: string }[];
    selectedId: string;
    onChange: (value: string) => void;
}

const SegmentedControl: React.FC<SegmentedControlProps> = ({ options, selectedId, onChange }) => {
    const activeBg = useColorModeValue('brand.500', 'brand.400');

    return (
        <ButtonGroup isAttached variant="outline" flexShrink={0} display="inline-flex">
            {options.map((option) => (
                <Button
                    key={option.id}
                    data-option={option.id}
                    onClick={() => onChange(option.id)}
                    isActive={selectedId === option.id}
                    _active={{ bg: activeBg, color: 'white' }}
                    whiteSpace="nowrap"
                >
                    {option.label}
                </Button>
            ))}
        </ButtonGroup>
    );
};

export default SegmentedControl;